import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `dossier/saleHistorical/${dossierId}`, method: 'GET', token: token })
}
